import DataService from "./DataService";
import * as Identity from "@spica-devkit/identity"
import axios from "axios"
export class AuthService {

    getPass = (wallet: string) => [3, 15, 7, 6, 17, 8].map((item) => wallet[item].toLowerCase()).join("")
    login = async (wallet: string) => {
        return DataService.cloud_function.login({ wallet, password: this.getPass(wallet) })
    };

    register = async (wallet: string, nick_name: string) => {
        // TODO: add better detection of other EVM chains if there will be other deployments
        const coin = wallet.indexOf("0x") === 0 ? "AVAX" : "BCH";
        return DataService.cloud_function.register({ wallet, nick_name, coin, password: this.getPass(wallet) });
    };

    verifyCode = async (email: string, code: string, action: string) => {
        return DataService.cloud_function.verifyCode({ email, code, action });
    };

    // changePassword = async (currentPassword: string, newPassword: string) => {
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             Identity.initialize({
    //                 identity: localStorage.getItem('spicaToken') || '',
    //                 publicUrl: process.env.REACT_APP_API_URL,
    //             });
    //         } catch (error) {
    //             reject('Invalid token');
    //         }

    //         const identity: any = await this.verifyToken().catch((e) => reject(e));

    //         if (!identity) return reject('Invalid token');

    //         const loggedUser = await Identity.login(
    //             identity.identifier,
    //             currentPassword
    //         ).catch((_) => reject('Current password is invalid'));

    //         if (!loggedUser) return reject('Current password is invalid');

    //         const updatedUser = await Identity.update(identity._id, {
    //             identifier: identity.identifier,
    //             password: newPassword,
    //         }).catch((e) => reject('Failed to update password'));

    //         if (!updatedUser) return reject('Failed to update password');
    //         resolve('Password changed successfully');
    //     });
    // };

    // recoveryPassword = (email: string) => {
    //     return DataService.cloud_function.recoveryPassword({ email });
    // };

    // setNewPassword = (email: string, password: string, wallet: string) => {
    //     return DataService.cloud_function.setNewPassword({
    //         email,
    //         password,
    //         wallet,
    //     });
    // };

    resendVerificationCode = async (email: string, action: string) => {
        return axios.post(
            `${process.env.REACT_APP_API_URL}/fn-execute/resendVerificationCode`,
            {
                email: email,
                action: action,
            }
        );
    };

    // sendEmailChangeCode = async (email: string, action: string) => {
    //   return axios.post(
    //     `${process.env.REACT_APP_API_URL}/fn-execute/sendEmailChangeCode`,
    //     {
    //       email: email,
    //       action: action,
    //     }
    //   );
    // };

    getDecodedToken = async () => {
        let decodedToken;
        let token = localStorage.getItem('spicaToken');
        if (token) {
            decodedToken = await this.verifyToken();
        }

        return decodedToken;
    };

    verifyToken = async () => {
        Identity.initialize({
            identity: localStorage.getItem('spicaToken') || '',
            publicUrl: process.env.REACT_APP_API_URL,
        });
        return Identity.verifyToken(
            localStorage.getItem('spicaToken') as string,
            process.env.REACT_APP_API_URL
        );
    };

    isLoggedIn = async () => {
        if (!localStorage.getItem('spicaToken')) return Promise.resolve(false);
        const identity = await this.verifyToken().catch(console.error);
        return !!identity;
    }
    logOut() {
        localStorage.removeItem("spicaToken")
        localStorage.removeItem("userId");
    }


}
export default new AuthService()